export default {
  upload_common: {
    required: 'คำถามนี้จำเป็น',
    max_length_500: 'โปรดตอบภายใน 500 คำ',
    please_enter_a_number: 'กรอกตัวเลข',
    unexpected_error: 'เกิดข้อผิดพลาดที่ไม่คาดคิด',
    temporarily_saved: 'บันทึกแล้ว',
    unanswered_items: 'มีคำถามที่ยังไม่มีคำตอบ',
    answer_questionnaire_select: 'เลือกแบบสอบถาม',
    entry: 'โปรดป้อนข้อมูล',
    target_select: 'เลือก',
    value_unit: 'ตัวเลข',
    unit: 'หน่วย',
    attach_documents: 'แนบไฟล์',
    textarea_placeholder: 'โปรดเขียนคำตอบของคุณเมื่อจำเป็น หรือหากคุณต้องการเพิ่มคำอธิบายเพิ่มเติม',
    // textarea_placeholder_with_file: '',
    temporary_storage: 'บันทึก',
    submit: 'ส่ง',
    last_saved_temporary: 'อัปเดตล่าสุด',
    There_are_unanswered_questions: 'มีคำถามที่ยังไม่มีคำตอบ',
    submitted_text: 'แบบสำรวจนี้ได้รับการส่งแล้ว',
    submitted_at: 'วันที่ส่ง',
    withdrawal_of_answer: 'ถอนการส่ง',
    withdrawal_accepted: 'ยอมรับการถอนแล้ว',
    help: 'ความช่วยเหลือ',
    example_of_evidence: 'ตัวอย่างหลักฐาน',
    save_temporary_answer: 'บันทึกแบบสำรวจ',
    saved_temporary_answer: 'คำตอบของคุณได้รับการบันทึกแล้ว',
    submit_answer: 'ส่งแบบสำรวจ',
    confirm_submit_answer: 'คุณแน่ใจหรือไม่ว่าต้องการส่งแบบสำรวจ',
    confirm_submit_shared_text: '\nคำตอบแบบสำรวจของคุณจะถูกแบ่งปันให้กับผู้ซื้อของคุณ',
    complete_submit_answer: 'ส่งแบบสำรวจแล้ว\nขอบคุณสำหรับความร่วมมือ',
    // recommend_asuene: '',
    // not_at_all: '',
    // absolutely: '',
    // let_us_know_your_thoughts: '',
    // thank_you_for_your_cooperation: '',
    // glad_to_support: '',
    // confirm_submit_shared_text: '',
    back_answer: 'ย้อนกลับ',
    close: 'ปิด',
    save_temporary_answer_and_prev: 'บันทึกและย้อนกลับ',
    save_temporary_answer_and_next: 'บันทึกและไปต่อ',
    prev: 'ย้อนกลับ',
    next: 'ถัดไป',
    question_group_question_download: 'ดาวน์โหลดแบบสำรวจ',
    question_group_answer_download: 'ดาวน์โหลดคำตอบ',
    question_group_download_answer_csv_title: 'คำถาม・คำตอบ(CSV)',
    question_group_download_answer_csv_description: 'ดาวน์โหลดคำตอบในรูปแบบ csv',
    question_group_download_answer_pdf_title: 'คำถาม・คำตอบ(PDF)',
    question_group_download_answer_pdf_description: 'ดาวน์โหลดคำตอบในรูปแบบ pdf',
    question_group_download_scorecard_pdf_title: 'บัตรคะแนน(PDF)',
    question_group_download_scorecard_pdf_description: 'ดาวน์โหลดคะแนนในรูปแบบ pdf',
    question_group_download_esg_award_svg_title: 'รางวัล ESG(SVG)',
    question_group_download_esg_award_svg_description: 'ดาวน์โหลดรางวัลในรูปแบบ svg',
    question_group_download_esg_award_pdf_title: 'รางวัล ESG(PDF)',
    question_group_download_esg_award_pdf_description: 'ดาวน์โหลดรางวัลในรูปแบบ pdf',
    request_survey_withdrawal: 'ขอถอนแบบสำรวจ',
    survey_withdrawal_description: 'คำขอถอนจะถูกส่งไปยังผู้ซื้อของคุณ\nโปรดระบุเหตุผลที่คุณต้องการถอนแบบสำรวจของคุณที่ด้านล่าง รายละเอียดคำขอของคุณจะถูกแชร์ไปยังผู้ซื้อของคุณ',
    reason_withdrawal_request: 'เหตุผลสำหรับการขอถอน',
    completed_withdrawal_request: 'คำขอถอนเงินของคุณได้รับการยอมรับแล้ว โปรดรอจนกว่าจะได้รับการอนุมัติ',
    send: 'ส่ง',
    cancel: 'ยกเลิก',
    balloon_title_withdrawal_request: 'คำขอถอนเงินของคุณได้รับการยอมรับแล้ว',
    no_survey: 'ไม่มีคำร้องขอแบบสำรวจ',
    failed_to_save_before_export: 'การบันทึกชั่วคราวก่อนการดาวน์โหล ล้มเหลว โปรดตรวจสอบว่าข้อมูลที่ป้อนถูกต้อง',
    filter_unfilled_questions: 'แสดงเฉพาะแบบสำรวจที่ยังไม่ได้ตอบ',
    no_unfilled_questions: 'มีคำถามที่ยังไม่ได้ตอบ',
    move_page: 'ไปที่หน้าถัดไป',
    confirm_move_page_message: 'คำตอบของคุณไม่ได้รับการบันทึก \nหากคุณย้ายไปหน้าอื่น คำตอบของคุณจะสูญหายคุณต้องการบันทึกคำตอบของคุณก่อนที่จะย้ายหรือไม่',
    confirm_without_save: 'ไม่บันทึก',
    confirm_with_save: 'บันทึก',
    error_save: 'ไม่สามารถบันทึกชั่วคราวได้ โปรดตรวจสอบคำตอบของคุณ',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: 'แบบสำรวจภายใต้การแก้ไข',
    unable_edit_someone_editing_survey: 'ไม่สามารถแก้ไขแบบสำรวจได้ในขณะนี้ เนื่องจากมีผู้ใช้กำลังแก้ไขอยู่',
    user_editing_survey: 'กำลังแก้ไขอยู่ในขณะนี้',
    reference_question: {
      // see_previous_answers: "",
      previous_answers: 'คำตอบก่อนหน้า',
      // overwrite_with_previous_answers: "",
      submitted_at: '(ส่งเมื่อ {submitted_at})',
      // related_question: "",
      click_to_expand: 'คลิกเพื่อขยาย',
      click_to_omit: 'คลิกเพื่อละเว้น',
      // description: "",
      answer_reference_function: 'ฟังก์ชันอ้างอิงคำตอบ',
      overwrite: 'เขียนทับ',
      overwrite_confirm: 'การดำเนินการนี้จะป้อนคำตอบก่อนหน้าสำหรับคำถามที่ตอบไว้ในการสำรวจก่อนหน้า\nคำถามใด ๆ ที่ตอบแล้วจะถูกเขียนทับ',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: 'รายการ',
      activity_amount: 'จำนวนเงิน',
      emission_factor: 'ค่าสัมประสิทธิ์การปล่อยก๊าซเรือนกระจก',
      emission_amount: 'การปล่อยก๊าซเรือนกระจก',
      unit_sale: 'ความเข้มข้นของการปล่อยก๊าซเรือนกระจก',
      total: 'รวม',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/หนึ่งล้านเยน',
    },
    label: {
      required_answer: 'คำตอบบังคับ',
      optional_answer: 'คำตอบทางเลือก',
      conditional_required_answer: 'การแยกสาขาคำตอบบังคับ',
      note: 'บันทึก',
      // evidence_attachments: "",
    },
    //  required_answer: '',
    //  optional_answer: '',
    //  conditional_required_answer: '',
    //  note: '',
    //  evidence_attachments: '',
    // no_available_in_pdf: ''
    // comparison_question_meta: '',
    // error_footer: '',
    // error_panel_title: '',
    // error_panel_description: '',
    // error_panel_support_text_1: '',
    // error_panel_support_label: '',
    // error_panel_support_text_2: '',
    // error_panel_resolved: '',
    // error: '',
    // error_revision_required: '',
    // alert: '',
    // alert_detected: '',
    question_group_download_answered_csv_title: 'คำถาม・คำตอบ(CSV)',
    question_group_download_answered_pdf_title: 'คำถาม・คำตอบ(PDF)',
  }
}
